import {
    GET_WEAPON_RECIPES_LOADING,
    GET_WEAPON_RECIPES_SUCCESS,
    GET_WEAPON_RECIPES_FAILURE
} from '../actionTypes'
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';
import { getRecursivelyAsync } from '../../utils/get-recursively-async';

export const getWeaponRecipesSuccess = payload => ({
    type: GET_WEAPON_RECIPES_SUCCESS,
    payload
})

export const getWeaponRecipesFailure = () => ({
    type: GET_WEAPON_RECIPES_FAILURE
})

export const getWeaponRecipesAsync = payload => dispatch => {
    return dispatch(getRecursivelyAsync('weapon-recipes', getWeaponRecipesSuccess, 0));
}